import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import {
    clearApiRegion,
    getUsersApiUrl,
    resolveUsersApiUrl,
} from '../../config';
import { readFromStorage, removeFromStorage } from '../webStorage';

const axiosConfig: AxiosRequestConfig = {
    baseURL: getUsersApiUrl(),
};
const authAxios = axios.create(axiosConfig);

const logout = () => {
    removeFromStorage('accessToken');
    removeFromStorage('refreshToken');
    removeFromStorage('user')
    removeFromStorage('role')
    clearApiRegion();
    window.location.reload();
    // (window as any).Intercom('shutdown');
};

authAxios.interceptors.request.use((config) => {
    const hasAuthorizationHeader = !!(config.headers as any)?.Authorization;

    if (!readFromStorage('accessToken') && !hasAuthorizationHeader) {
        clearApiRegion();
    }

    return {
        ...config,
        baseURL: getUsersApiUrl(),
        url: resolveUsersApiUrl(config.url),
    };
});

// Add a response interceptor
authAxios.interceptors.response.use(
    (response) => {
        if (response?.data?.error === 'No permission!') logout();
        return response;
    },
    async (error) => {
        const err = { ...error };
        return Promise.reject(err);
    },
);

export const authAxiosQuery =
    (): BaseQueryFn<{
        url: string;
        method: AxiosRequestConfig['method'];
        data?: AxiosRequestConfig['data'];
        headers?: AxiosRequestConfig['headers'];
    }> =>
        async ({ url, method, data, headers }) => {
            try {
                const result = await authAxios({ url, method, data, headers });
                return { data: result.data };
            } catch (axiosError) {
                const err = axiosError as AxiosError;
                return {
                    error: { status: err.response?.status, data: err.response?.data },
                };
            }
        };

export default authAxios;
